import { EditorDOMUtils } from 'Editor/services/_Common/DOM';
import { WidgetViewModel } from './WidgetViewModel';
import { TableOptionsWidgetView } from '../../Views';
import ReduxInterface from 'Editor/services/ReduxInterface/ReduxInteface';

export class TableOptionsWidgetModel extends WidgetViewModel<'tableOptions'> {
  constructor(
    Visualizer: Editor.Visualizer.State,
    refView: Editor.Visualizer.WidgetDataMapper['tableOptions']['view'],
    props: Editor.Visualizer.WidgetDataMapper['tableOptions']['props'],
  ) {
    super(Visualizer, refView, props);

    this.container.dataset.type = 'tableOptions';
  }

  render() {
    const parent = this.container.parentElement;
    const ref = this.refView;
    // set widget position
    const offsets = EditorDOMUtils.getOffsets(ref);
    if (offsets) {
      const zoom = ReduxInterface.getZoomValue() || 1;

      this.container.style.position = 'absolute';
      this.container.style.top = `${offsets.top}px`;

      if (this.Visualizer.getLayoutType?.() === 'PAGE') {
        if (parent && ref) {
          const refLeft = ref.getBoundingClientRect().left;
          const parentLeft = parent.getBoundingClientRect().left;
          this.container.style.left = `${(refLeft - parentLeft) / zoom}px`;
        }
      } else {
        this.container.style.left = `${offsets.left}px`;
      }

      this.container.style.width = `0px`;
      this.container.style.height = `${offsets.height / zoom}px`;
    }

    let polygons: Editor.Elements.Table.CellPolygonArea[] = [];
    const selectedCells = this.refView.getSelectedCells();
    if (selectedCells.length > 1) {
      polygons = this.refView.getCellsPolygonAreas(selectedCells);
    }

    this.renderReactComponent(
      <TableOptionsWidgetView
        columnWidths={this.refView.getComputedColumnWidths()}
        rowHeights={this.refView.getComputedRowHeights()}
        selection={{
          polygon: polygons || [],
          columns: this.props.selection?.columns || [],
          rows: this.props.selection?.rows || [],
          fullySelected: {
            row: this.props.selection?.fullySelected?.row || [],
            column: this.props.selection?.fullySelected?.column || [],
          },
        }}
        offsets={offsets}
        insert={this.refView.shortcutInsert}
        remove={this.refView.shortcutRemove}
        select={this.refView.shortcutSelect}
        resize={this.refView.resize}
      />,
    );
  }
}
